import React, { useState } from "react";
import { Input } from "../ui/input";
import Button from "./button";
import EditableField from "./EditableField";

export interface ListObject {
    key: string | null;
    value: string;
}

interface ListProps {
    list: ListObject[];
    onChange: (list: ListObject[]) => void;
    placeholder: string;
}

export default function List({ list, onChange, placeholder }: ListProps) {
    const [text, setText] = useState<string>("");

    function addToList(): void {
        const newList = [...list];
        if (text.length > 2) {
            newList.push({ key: null, value: text });
            setText("");
        }
        onChange(newList);
    }

    function removeFromList(index: number): void {
        const newList = [...list];
        newList.splice(index, 1);
        onChange(newList);
    }

    function updateValueOnIndex(index: number, newValue: string): void {
        const newList = [...list];
        if (newList?.[index]?.value) {
            newList[index].value = newValue;
        }
        onChange(newList);
    }

    return (
        <div>
            <div className="flex items-center gap-2">
                <Input value={text} placeholder={placeholder} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addToList()} />
                <Button onClick={addToList}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                </Button>
            </div>
            {list?.length > 0 && (
                <div className="mt-2 overflow-hidden rounded border">
                    {list?.map((item, index) => {
                        return (
                            <div className={`flex items-center justify-between gap-2 px-4 py-2 ${index % 2 !== 0 ? "bg-slate-50 dark:bg-slate-800" : "bg-white dark:bg-slate-900"}`}>
                                <EditableField value={item.value} onChange={(value) => updateValueOnIndex(index, value)} />
                                <Button onClick={() => removeFromList(index)} variant={"suttle"} size={"small"} className="text-slate-500 dark:text-slate-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </Button>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
